import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngxui-NgxUiTooling',
  template: `
    <p>
      ngx-ui-tooling works!
    </p>
  `,
  styles: []
})
export class NgxUiToolingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
